// ============================================================
//  Custom Utilities for Searle Digital Theme (Tinker)
// ============================================================

document.addEventListener('DOMContentLoaded', () => {
  // 1️⃣ Hide "Type" dropdowns
  document.querySelectorAll('.variant-option').forEach(option => {
    const select = option.querySelector('select[name="options[Type]"]');
    if (select) option.style.display = 'none';
  });

  // 2️⃣ Clean Measura unit text
  const cleanMeasura = () => {
    document.querySelectorAll('.measura-unit-price').forEach(el => {
      const cleaned = el.textContent.replace(/\/\s*m/g, '').trim();
      if (el.textContent !== cleaned) el.textContent = cleaned;
    });
  };
  cleanMeasura();
  document.addEventListener('shopify:section:load', cleanMeasura);
  new MutationObserver(cleanMeasura)
    .observe(document.body, { childList: true, subtree: true });

  // 3️⃣ Smart Mega Menu hover logic
  const DELAY = 300, EXIT_DELAY = 800, MOUSE_HISTORY = 5;
  let activeTrigger = null, mousePositions = [], timer = null;
  const getYIntercept = (p, s) => p.y - s * p.x;

  document.addEventListener('mousemove', e => {
    mousePositions.push({ x: e.pageX, y: e.pageY });
    if (mousePositions.length > MOUSE_HISTORY) mousePositions.shift();
  });

  const menuItems = document.querySelectorAll('.header__menu-item');

  const shouldDelay = (newTrigger, oldTrigger) => {
    if (!activeTrigger) return false;
    const oldMenu = oldTrigger.querySelector('.mega-menu, .mega-menu__content');
    if (!oldMenu) return false;
    const rect = oldMenu.getBoundingClientRect();
    const upperLeft = { x: rect.left, y: rect.top };
    const lowerLeft = { x: rect.left, y: rect.bottom };
    const slope = (lowerLeft.y - upperLeft.y) / ((lowerLeft.x - upperLeft.x) || 1);
    const upperY = getYIntercept(upperLeft, slope);
    const lowerY = getYIntercept(lowerLeft, slope);
    const last = mousePositions.at(-1);
    if (!last) return false;
    return last.y > slope * last.x + upperY && last.y < slope * last.x + lowerY;
  };

  const activate = trigger => {
    deactivate(activeTrigger);
    activeTrigger = trigger;
    trigger.querySelector('.mega-menu, .mega-menu__content')?.classList.add('is-visible');
  };

  const deactivate = trigger => {
    trigger?.querySelector('.mega-menu, .mega-menu__content')?.classList.remove('is-visible');
  };

  const possiblyActivate = trigger => {
    clearTimeout(timer);
    if (activeTrigger === trigger) return;
    const delay = shouldDelay(trigger, activeTrigger) ? DELAY : 0;
    timer = setTimeout(() => {
      deactivate(activeTrigger);
      activate(trigger);
    }, delay);
  };

  const delayedDeactivate = trigger => {
    clearTimeout(timer);
    timer = setTimeout(() => deactivate(trigger), EXIT_DELAY);
  };

  menuItems.forEach(trigger => {
    const menu = trigger.querySelector('.mega-menu, .mega-menu__content');
    if (!menu) return;
    trigger.addEventListener('mouseenter', () => possiblyActivate(trigger));
    trigger.addEventListener('mouseleave', () => delayedDeactivate(trigger));
    menu.addEventListener('mouseenter', () => clearTimeout(timer));
    menu.addEventListener('mouseleave', () => delayedDeactivate(trigger));
  });
});

/* ==========================================================
 * 4️⃣  Free Sample button (Tinker-compatible, hard limit 10)
 * ========================================================== */
document.addEventListener('DOMContentLoaded', () => {
  const sampleButtons = document.querySelectorAll('#free-sample-btn, .btn-sample, [data-free-sample]');
  if (!sampleButtons.length) return;

  // --- Helpers ---
  const fetchCart = async () => {
    const res = await fetch('/cart.js?t=' + Date.now(), { cache: 'no-store' });
    if (!res.ok) throw new Error('cart fetch failed');
    return res.json();
  };

  const getProductData = () =>
    window.ShopifyAnalytics?.meta?.product ||
    window.meta?.product ||
    window.Shopify?.product ||
    null;

  const findSampleVariantId = (btn, productData) => {
    const dataId = btn?.dataset?.sampleVariantId;
    if (dataId && /^\d+$/.test(String(dataId))) return Number(dataId);

    if (productData?.variants?.length) {
      const v = productData.variants.find(vv =>
        (vv.name && vv.name.toLowerCase().includes('free sample')) ||
        (vv.public_title && vv.public_title.toLowerCase().includes('free sample')) ||
        (vv.title && String(vv.title).toLowerCase().includes('free sample'))
      );
      if (v?.id) return Number(v.id);
    }
    return null;
  };

  const getProductTitle = (productData) => {
    let productTitle = 'this product';
    if (productData?.title) {
      productTitle = productData.title;
    } else {
      const titleEl = document.querySelector('[class*="title"]');
      if (titleEl && titleEl.textContent.trim()) productTitle = titleEl.textContent.trim();
    }
    return productTitle;
  };

  const totalFreeSamples = (cart) =>
    cart.items.reduce((acc, item) => {
      const t = (item.product_title || item.title || '').toLowerCase();
      return t.includes('free sample') ? acc + item.quantity : acc;
    }, 0);

  // --- Styling for Added State ---
  const style = document.createElement('style');
  style.textContent = `
    .btn-sample--added {
      background-color: #f0f0f0 !important;
      color: #888 !important;
      border: 1px solid #ccc !important;
      cursor: not-allowed !important;
    }
  `;
  document.head.appendChild(style);

  // --- Main Logic ---
  sampleButtons.forEach(btn => {
    const productData = getProductData();
    if (!productData) return;

    const productTitle = getProductTitle(productData);
    const sampleVariantId = findSampleVariantId(btn, productData);
    if (!sampleVariantId) return;

    const refreshButton = async () => {
      try {
        const cart = await fetchCart();
        const already = cart.items.some(i => i.variant_id === sampleVariantId);
        btn.textContent = already ? 'Sample added' : 'Order a Free Sample';
        btn.disabled = already;
        btn.classList.toggle('btn-sample--added', already);
      } catch {}
    };

    refreshButton();
    document.addEventListener('shopify:section:load', refreshButton);

    btn.addEventListener('click', async (e) => {
      e.preventDefault();
      if (btn.disabled || btn.classList.contains('is-adding')) return;

      btn.classList.add('is-adding');

      try {
        // Always pull a fresh cart before acting
        const cart = await fetchCart();

        // ✅ 1. Compute total samples *before adding*
        const currentSamples = totalFreeSamples(cart);

        if (currentSamples >= 10) {
          alert('You can only order up to 10 free samples per order.');
          sampleButtons.forEach(b => b.disabled = true);
          return;
        }

        // ✅ 2. Prevent duplicate of this sample (same variant)
        const already = cart.items.some(i => i.variant_id === sampleVariantId);
        if (already) {
          alert(`You already have a free sample of "${productTitle}" in your basket.`);
          await refreshButton();
          return;
        }

        // ✅ 3. Add sample
        const addRes = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: sampleVariantId, quantity: 1 })
        });

        if (!addRes.ok) throw new Error('add failed');

        // ✅ 4. Recheck cart to confirm total
        const updatedCart = await fetchCart();
        if (totalFreeSamples(updatedCart) > 10) {
          // If limit exceeded due to race condition → remove last added
          alert('You have reached the limit of 10 free samples per order.');
          const newItem = updatedCart.items.find(i => i.variant_id === sampleVariantId);
          if (newItem) {
            await fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: newItem.key, quantity: 0 })
            });
          }
          return;
        }

        // ✅ 5. Success
        btn.textContent = 'Sample added';
        btn.disabled = true;
        btn.classList.add('btn-sample--added');
        window.location.href = '/cart';
      } catch (err) {
        console.error('Free sample add failed:', err);
        alert('Sorry, we couldn’t add that free sample. Please try again.');
      } finally {
        btn.classList.remove('is-adding');
      }
    });
  });
});

/* ==========================================================
 *  Hide "Type" variant dropdown permanently
 * ========================================================== */
document.addEventListener('DOMContentLoaded', () => {
  const hideTypeSelectors = () => {
    document.querySelectorAll('.variant-option').forEach(option => {
      const select = option.querySelector('select[name="options[Type]"]');
      if (select) option.style.display = 'none';
    });
  };

  // Run immediately
  hideTypeSelectors();

  // Run again whenever Shopify re-renders variant options
  const observer = new MutationObserver(() => hideTypeSelectors());
  observer.observe(document.body, { childList: true, subtree: true });

  // Also run when theme sections reload dynamically
  document.addEventListener('shopify:section:load', hideTypeSelectors);
});



/* ==========================================================
 *  Basket Redirect
 * ========================================================== */
  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('form[action^="/cart/add"]').forEach(function(form) {
      form.addEventListener('submit', function() {
        // Redirect straight to the basket after adding
        setTimeout(function() {
          window.location.href = '/cart';
        }, 1500); // slight delay helps ensure the cart updates
      });
    });
  });


/* ==========================================================
 *  Free Sample Add To Cart
 * ========================================================== */

function addSampleToCart(button) {
  const variantId = button.dataset.variantId;

  if (!variantId) return;

  button.disabled = true;
  button.textContent = 'Adding…';

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify({
      id: variantId,
      quantity: 1
    })
  })
    .then(response => {
      if (!response.ok) throw new Error('Add failed');
      return response.json();
    })
    .then(() => {
      window.location.href = '/cart';
    })
    .catch(() => {
      button.disabled = false;
      button.textContent = 'Order a free sample';
      alert('Sorry — something went wrong adding the sample.');
    });
}

